var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "mb-3" }, [
        _c("b", [_vm._v(_vm._s(_vm.message.text))])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "mb-4" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("message.bank_transfer.confirm_promptpay")) +
              "\n        "
          ),
          _c("div", [_c("strong", [_vm._v(_vm._s(_vm.expireDateTime))])])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-4" }, [
          _c("h3", [
            _vm._v("ยอดที่ต้องชำระ: "),
            _c("span", { staticClass: "text-orange" }, [
              _vm._v(" " + _vm._s(_vm._f("currency")(_vm.totalPrice)) + " ")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.paymentSuccess
        ? _c("div", { staticClass: "text-center" }, [
            _c("i", { staticClass: "fas fa-check-circle -status-accepted" }),
            _vm._v("\n      " + _vm._s(_vm.$t("message.success")) + "\n    ")
          ])
        : _c(
            "div",
            [
              _c("qr-code-payment", {
                ref: "qrCodePayment",
                on: { checkQrPayment: _vm.checkQrPayment }
              }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "text-remark" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.promptpay.payment_remark")) +
                    "\n      "
                )
              ])
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ecc136e4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecc136e4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/PromptpayMessage.vue
// module id = 2112
// module chunks = 0